export default __webpack_public_path__ + "autoracing.png";